import axios from 'axios';
import { setApiLoading } from './stores/loadingSlice';

let activeRequests = 0;
let store;

export const injectStore = _store => {
  store = _store;
};

// request interceptor
axios.interceptors.request.use(
  (config) => {
    // Add auth token
    config.headers['authToken'] = (localStorage.getItem('authToken') !== null) ? localStorage.getItem("authToken") : undefined;
    
    // Add step-up token if it exists
    const stepUpToken = localStorage.getItem('da_stepUpToken') || sessionStorage.getItem('da_stepUpToken');
    if (stepUpToken) {
      config.headers['x-step-up-token'] = stepUpToken;
    }
    
    // Manage loading state
    if (!config.headers['skipLoader']) {
      activeRequests++;
      if (activeRequests === 1 && store) {
        store.dispatch(setApiLoading(true));
      }
    }
    
    return config;
  }, 
  (error) => {
    if (!error.config?.headers?.['skipLoader']) {
      activeRequests--;
      if (activeRequests === 0 && store) {
        store.dispatch(setApiLoading(false));
      }
    }
    return Promise.reject(error);
  }
);


// response interceptor
axios.interceptors.response.use(
  (response) => {
    if (!response.config?.headers?.['skipLoader']) {
      activeRequests--;
      if (activeRequests === 0 && store) {
        store.dispatch(setApiLoading(false));
      }
    }
    return response;
  }, 
  async (error) => {
    if (!error.config?.headers?.['skipLoader']) {
      activeRequests--;
      if (activeRequests === 0 && store) {
        store.dispatch(setApiLoading(false));
      }
    }
    
    const originalRequest = error.config;
    
    // Handle unauthorized and network errors
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');
      
      if (refreshToken) {
        try {
          const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/refresh`, { refreshToken }, {
            headers: { 'skipLoader': true }
          });
          
          if (res.status === 200) {
            localStorage.setItem('authToken', res.data.token);
            originalRequest.headers['authToken'] = res.data.token;
            return axios(originalRequest);
          }
        } catch (refreshError) {
          // Refresh token is invalid or expired
          localStorage.removeItem('authToken');
          localStorage.removeItem('refreshToken');
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      } else {
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        window.location.href = "/login";
      }
    } else if (error?.message === 'Network Error' || error?.code === 'ERR_NETWORK') {
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      window.location.href = "/login";
    }
    
    return Promise.reject(error);
  }
);

export default axios;